// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2MnCktXJMnJfkIwfrA_eXP","title":"_1bt2eflKdMGShds_uJTazD","subtitle":"_37L0A0n_3Rsfb11WkgvUDU","actions":"_2u3P3P__E2UEHSTnupaBd1"};